import type { DpEvent } from '@/core/events/DpEvent';

export class CurrentUserWorkstationChangedEvent implements DpEvent {
  static readonly eventName = 'Workstation:CurrentUserWorkstationChanged';

  readonly name = CurrentUserWorkstationChangedEvent.eventName;

  constructor(public readonly workstationId: string | null) {}
}
